"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: auth/auth-login-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fauth%2Fauth-login-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthLoginServiceClient = exports.RefreshResponse = exports.RefreshRequest = exports.GoogleLoginResponse = exports.LoginWithTokenIdRequest = exports.LoginWithIapTokenRequest = exports.GoogleUser = exports.LoginResponse = exports.LoginRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const alias_1 = require("../common/alias");
const device_token_1 = require("../common/device-token");
const token_1 = require("../common/token");
const credentials_1 = require("./credentials");
const session_1 = require("./session");
const protobufPackage = 'com.step.auth.proto';
function createBaseLoginRequest() {
    return {
        alias: alias_1.Alias.fromPartial({}),
        credentials: [],
        sessionLifetimeMs: '0',
        device: undefined,
        clientTimeMs: '0',
    };
}
exports.LoginRequest = {
    fromJSON(object) {
        const message = {
            alias: isSet(object.alias) ? alias_1.Alias.fromJSON(object.alias) : alias_1.Alias.fromPartial({}),
            credentials: globalThis.Array.isArray(object?.credentials)
                ? object.credentials.map((e) => credentials_1.Credential.fromJSON(e))
                : [],
        };
        if (isSet(object.sessionLifetimeMs)) {
            message.sessionLifetimeMs = globalThis.String(object.sessionLifetimeMs);
        }
        if (isSet(object.device)) {
            message.device = device_token_1.DeviceToken.fromJSON(object.device);
        }
        if (isSet(object.clientTimeMs)) {
            message.clientTimeMs = globalThis.String(object.clientTimeMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.alias !== undefined) {
            obj.alias = alias_1.Alias.toJSON(message.alias);
        }
        if (message.credentials?.length) {
            obj.credentials = message.credentials.map((e) => credentials_1.Credential.toJSON(e));
        }
        if (message.sessionLifetimeMs !== undefined && message.sessionLifetimeMs !== '0') {
            obj.sessionLifetimeMs = message.sessionLifetimeMs;
        }
        if (message.device !== undefined) {
            obj.device = device_token_1.DeviceToken.toJSON(message.device);
        }
        if (message.clientTimeMs !== undefined && message.clientTimeMs !== '0') {
            obj.clientTimeMs = message.clientTimeMs;
        }
        return obj;
    },
    create(base) {
        return exports.LoginRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLoginRequest();
        message.alias = (object.alias !== undefined && object.alias !== null)
            ? alias_1.Alias.fromPartial(object.alias)
            : alias_1.Alias.fromPartial({});
        message.credentials = object.credentials?.map((e) => credentials_1.Credential.fromPartial(e)) || [];
        message.sessionLifetimeMs = object.sessionLifetimeMs ?? '0';
        message.device = (object.device !== undefined && object.device !== null)
            ? device_token_1.DeviceToken.fromPartial(object.device)
            : undefined;
        message.clientTimeMs = object.clientTimeMs ?? '0';
        return message;
    },
};
function createBaseLoginResponse() {
    return {
        userId: '',
        refreshToken: token_1.AuthToken.fromPartial({}),
        accessToken: token_1.AuthToken.fromPartial({}),
        sessionMetadata: undefined,
    };
}
exports.LoginResponse = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            refreshToken: isSet(object.refreshToken)
                ? token_1.AuthToken.fromJSON(object.refreshToken)
                : token_1.AuthToken.fromPartial({}),
            accessToken: isSet(object.accessToken)
                ? token_1.AuthToken.fromJSON(object.accessToken)
                : token_1.AuthToken.fromPartial({}),
        };
        if (isSet(object.sessionMetadata)) {
            message.sessionMetadata = session_1.SessionMetadata.fromJSON(object.sessionMetadata);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.refreshToken !== undefined) {
            obj.refreshToken = token_1.AuthToken.toJSON(message.refreshToken);
        }
        if (message.accessToken !== undefined) {
            obj.accessToken = token_1.AuthToken.toJSON(message.accessToken);
        }
        if (message.sessionMetadata !== undefined) {
            obj.sessionMetadata = session_1.SessionMetadata.toJSON(message.sessionMetadata);
        }
        return obj;
    },
    create(base) {
        return exports.LoginResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLoginResponse();
        message.userId = object.userId ?? '';
        message.refreshToken = (object.refreshToken !== undefined && object.refreshToken !== null)
            ? token_1.AuthToken.fromPartial(object.refreshToken)
            : token_1.AuthToken.fromPartial({});
        message.accessToken = (object.accessToken !== undefined && object.accessToken !== null)
            ? token_1.AuthToken.fromPartial(object.accessToken)
            : token_1.AuthToken.fromPartial({});
        message.sessionMetadata =
            (object.sessionMetadata !== undefined && object.sessionMetadata !== null)
                ? session_1.SessionMetadata.fromPartial(object.sessionMetadata)
                : undefined;
        return message;
    },
};
function createBaseGoogleUser() {
    return { id: '', name: '', email: '', firstName: '', lastName: '', pictureUrl: '' };
}
exports.GoogleUser = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            email: isSet(object.email) ? globalThis.String(object.email) : '',
        };
        if (isSet(object.name)) {
            message.name = globalThis.String(object.name);
        }
        if (isSet(object.firstName)) {
            message.firstName = globalThis.String(object.firstName);
        }
        if (isSet(object.lastName)) {
            message.lastName = globalThis.String(object.lastName);
        }
        if (isSet(object.pictureUrl)) {
            message.pictureUrl = globalThis.String(object.pictureUrl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.name !== undefined && message.name !== '') {
            obj.name = message.name;
        }
        if (message.email !== '') {
            obj.email = message.email;
        }
        if (message.firstName !== undefined && message.firstName !== '') {
            obj.firstName = message.firstName;
        }
        if (message.lastName !== undefined && message.lastName !== '') {
            obj.lastName = message.lastName;
        }
        if (message.pictureUrl !== undefined && message.pictureUrl !== '') {
            obj.pictureUrl = message.pictureUrl;
        }
        return obj;
    },
    create(base) {
        return exports.GoogleUser.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGoogleUser();
        message.id = object.id ?? '';
        message.name = object.name ?? '';
        message.email = object.email ?? '';
        message.firstName = object.firstName ?? '';
        message.lastName = object.lastName ?? '';
        message.pictureUrl = object.pictureUrl ?? '';
        return message;
    },
};
function createBaseLoginWithIapTokenRequest() {
    return { jwt: '', sessionLifetimeMs: '0' };
}
exports.LoginWithIapTokenRequest = {
    fromJSON(object) {
        const message = {
            jwt: isSet(object.jwt) ? globalThis.String(object.jwt) : '',
        };
        if (isSet(object.sessionLifetimeMs)) {
            message.sessionLifetimeMs = globalThis.String(object.sessionLifetimeMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.jwt !== '') {
            obj.jwt = message.jwt;
        }
        if (message.sessionLifetimeMs !== undefined && message.sessionLifetimeMs !== '0') {
            obj.sessionLifetimeMs = message.sessionLifetimeMs;
        }
        return obj;
    },
    create(base) {
        return exports.LoginWithIapTokenRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLoginWithIapTokenRequest();
        message.jwt = object.jwt ?? '';
        message.sessionLifetimeMs = object.sessionLifetimeMs ?? '0';
        return message;
    },
};
function createBaseLoginWithTokenIdRequest() {
    return { idToken: '', sessionLifetimeMs: '0' };
}
exports.LoginWithTokenIdRequest = {
    fromJSON(object) {
        const message = {
            idToken: isSet(object.idToken) ? globalThis.String(object.idToken) : '',
        };
        if (isSet(object.sessionLifetimeMs)) {
            message.sessionLifetimeMs = globalThis.String(object.sessionLifetimeMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.idToken !== '') {
            obj.idToken = message.idToken;
        }
        if (message.sessionLifetimeMs !== undefined && message.sessionLifetimeMs !== '0') {
            obj.sessionLifetimeMs = message.sessionLifetimeMs;
        }
        return obj;
    },
    create(base) {
        return exports.LoginWithTokenIdRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLoginWithTokenIdRequest();
        message.idToken = object.idToken ?? '';
        message.sessionLifetimeMs = object.sessionLifetimeMs ?? '0';
        return message;
    },
};
function createBaseGoogleLoginResponse() {
    return {
        user: exports.GoogleUser.fromPartial({}),
        refreshToken: token_1.AuthToken.fromPartial({}),
        accessToken: token_1.AuthToken.fromPartial({}),
    };
}
exports.GoogleLoginResponse = {
    fromJSON(object) {
        const message = {
            user: isSet(object.user) ? exports.GoogleUser.fromJSON(object.user) : exports.GoogleUser.fromPartial({}),
            refreshToken: isSet(object.refreshToken)
                ? token_1.AuthToken.fromJSON(object.refreshToken)
                : token_1.AuthToken.fromPartial({}),
            accessToken: isSet(object.accessToken)
                ? token_1.AuthToken.fromJSON(object.accessToken)
                : token_1.AuthToken.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.user !== undefined) {
            obj.user = exports.GoogleUser.toJSON(message.user);
        }
        if (message.refreshToken !== undefined) {
            obj.refreshToken = token_1.AuthToken.toJSON(message.refreshToken);
        }
        if (message.accessToken !== undefined) {
            obj.accessToken = token_1.AuthToken.toJSON(message.accessToken);
        }
        return obj;
    },
    create(base) {
        return exports.GoogleLoginResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGoogleLoginResponse();
        message.user = (object.user !== undefined && object.user !== null)
            ? exports.GoogleUser.fromPartial(object.user)
            : exports.GoogleUser.fromPartial({});
        message.refreshToken = (object.refreshToken !== undefined && object.refreshToken !== null)
            ? token_1.AuthToken.fromPartial(object.refreshToken)
            : token_1.AuthToken.fromPartial({});
        message.accessToken = (object.accessToken !== undefined && object.accessToken !== null)
            ? token_1.AuthToken.fromPartial(object.accessToken)
            : token_1.AuthToken.fromPartial({});
        return message;
    },
};
function createBaseRefreshRequest() {
    return { refreshToken: '', clientTimeMs: '0' };
}
exports.RefreshRequest = {
    fromJSON(object) {
        const message = {
            refreshToken: isSet(object.refreshToken) ? globalThis.String(object.refreshToken) : '',
        };
        if (isSet(object.clientTimeMs)) {
            message.clientTimeMs = globalThis.String(object.clientTimeMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.refreshToken !== '') {
            obj.refreshToken = message.refreshToken;
        }
        if (message.clientTimeMs !== undefined && message.clientTimeMs !== '0') {
            obj.clientTimeMs = message.clientTimeMs;
        }
        return obj;
    },
    create(base) {
        return exports.RefreshRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRefreshRequest();
        message.refreshToken = object.refreshToken ?? '';
        message.clientTimeMs = object.clientTimeMs ?? '0';
        return message;
    },
};
function createBaseRefreshResponse() {
    return { accessToken: token_1.AuthToken.fromPartial({}) };
}
exports.RefreshResponse = {
    fromJSON(object) {
        const message = {
            accessToken: isSet(object.accessToken)
                ? token_1.AuthToken.fromJSON(object.accessToken)
                : token_1.AuthToken.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accessToken !== undefined) {
            obj.accessToken = token_1.AuthToken.toJSON(message.accessToken);
        }
        return obj;
    },
    create(base) {
        return exports.RefreshResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRefreshResponse();
        message.accessToken = (object.accessToken !== undefined && object.accessToken !== null)
            ? token_1.AuthToken.fromPartial(object.accessToken)
            : token_1.AuthToken.fromPartial({});
        return message;
    },
};
/**
 * Authentication Service API.
 *
 * Implements JWT authentication. User needs to first start onboarding using
 * AuthInternalService and then use the Login method to continue to login or
 * recovery flow. Login method returns tokens that are cryptographically
 * signed by the auth server using a configured private key. Other services
 * that need to authenticate customers are provisioned with a public key that
 * can verify token signatures. Also supports Google login via IAP or OIDC for
 * backoffice (admin-web) login.
 *
 * Refresh token is used to request new access tokens. It is typically a long
 * lived token, with the lifetime controlled by the user requesting it.
 *
 * The Access token is a short lived token used to perform API calls. Clients
 * are expected to refresh tokens before they expire.
 */
class AuthLoginServiceClient {
    rpc;
    name = 'com.step.auth.proto.AuthLoginService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/auth';
    methods = [{
            name: 'Login',
            requestType: exports.LoginRequest,
            responseType: exports.LoginResponse,
            authenticationOptions: undefined,
            adminTokenType: undefined,
        }, {
            name: 'LoginWithIapToken',
            requestType: exports.LoginWithIapTokenRequest,
            responseType: exports.GoogleLoginResponse,
            authenticationOptions: undefined,
            adminTokenType: undefined,
        }, {
            name: 'LoginWithTokenId',
            requestType: exports.LoginWithTokenIdRequest,
            responseType: exports.GoogleLoginResponse,
            authenticationOptions: undefined,
            adminTokenType: undefined,
        }, {
            name: 'Refresh',
            requestType: exports.RefreshRequest,
            responseType: exports.RefreshResponse,
            authenticationOptions: undefined,
            adminTokenType: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Logs in an existing principal (user).
     */
    login(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Logs in a user using IAP JWT. Validates the token and returns back Step JWT
     * tokens.
     */
    loginWithIapToken(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Uses Google OIDC to authenticate users and exchange OIDC ID token for
     * Step JWT tokens.
     */
    loginWithTokenId(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Refreshes a token. Used to get a new access token given an existing
     * refresh token.
     */
    refresh(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.AuthLoginServiceClient = AuthLoginServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=auth-login-service.js.map